import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
class ArticleSearch extends Component {
  render() {
    const { placeholder, visible, name } = this.props;
    return (
      <div
        className={
          visible === true
            ? "articleSearch_box"
            : "articleSearch_box display_none"
        }
      >
        <div className="articleSearch_box_div">
          <div className="articleSearch_box_div_img fl">
            <img
              alt=""
              src={require("../../../../images/search/search_2.png")}
            ></img>
          </div>
          <div className="articleSearch_box_div_input fl">
            <input
              onClick={this.handleVisibleSearch}
              placeholder={placeholder}
              value={name}
              readOnly
            ></input>
          </div>
        </div>
      </div>
    );
  }
  handleVisibleSearch = () => {
    this.props.handleVisibleSearch();
    this.props.handleCloseDataList();
  };
}

export default ArticleSearch;



// WEBPACK FOOTER //
// ./src/containers/ArticleList/components/ArticleSearch/index.js